module.exports = __webpack_public_path__ + "img/ea.ea3328e16.svg";